import React, { useRef } from "react";
import CapEditableTable from "./CapEditableTable";
import EditableTable from "./EditableTable";
import { useFetchInventoryQuery } from "features/store";
import { TableTitleStyles } from "./Inventory.style";
import CapMaterialsTable from "./CapMaterialsTable";

const CapMaterialTable = ({
  dataSource, 
  loading,
  filterOptions,
  otherMaterialPagination,
  onOtherMaterialPaginationChange,
  otherMaterialTotalCount,
  capMaterialPagination,
  onCapMaterialPaginationChange,
  onOtherMaterialFiltersChange,
  onActivityLogClick,
}) => {
  const safeDataSource = Array.isArray(dataSource) ? dataSource : [];
  const otherMaterial = (filterOptions?.other_material_names?.length
    ? filterOptions.other_material_names
    : [...new Set(safeDataSource.map(item => item?.color_cloth?.other_material_name))]
  ).filter((it) => it != null);
  const lastOtherMaterialFilterRef = useRef(null);

  const material = "Edit Material"
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      // render: (text, record, index) => index + 1,
      // sorter: (a, b) => parseInt(a.id) - parseInt(b.id),
    },

    {
      title: "Material Name",
      key: "other_material_name",
      dataIndex: ["color_cloth", "other_material_name"],
      filters: otherMaterial.map(client => ({
        text: client,
        value: client,
      })),
      onFilter: (value, record) =>
        String(record?.color_cloth?.other_material_name || "").trim().toLowerCase() ===
        String(value || "").trim().toLowerCase(),
      filterSearch: true,
    },
    {
      title: "Plastic Bag Type",
      dataIndex: ["color_cloth", "plastic_bag_type"]
    },
    {
      title: "Carton Type",
      dataIndex: ["color_cloth", "carton_type"]
    },
    {
      title: "Card Board Type",
      dataIndex: ["color_cloth", "Card board type"],
   
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: "15%",
      editable: true,
    },
  ];

  const handleOtherMaterialTableChange = (_pagination, filters) => {
    const nextOtherMaterialName =
      Array.isArray(filters?.other_material_name) && filters.other_material_name.length
        ? filters.other_material_name[0]
        : null;

    const prevOtherMaterialName = lastOtherMaterialFilterRef.current ?? null;
    if (prevOtherMaterialName === nextOtherMaterialName) {
      // Most likely a pagination/sort change; don't reset pagination or refetch.
      return;
    }
    lastOtherMaterialFilterRef.current = nextOtherMaterialName;

    if (typeof onOtherMaterialFiltersChange === "function") {
      onOtherMaterialFiltersChange({ other_material_name: nextOtherMaterialName });
    }

    // Reset to page 1 when filters change (keep pagination flow intact).
    if (typeof onOtherMaterialPaginationChange === "function") {
      const currentSize = otherMaterialPagination?.pageSize || 10;
      onOtherMaterialPaginationChange(1, currentSize);
    }
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
    {/* <TableTitleStyles>Material</TableTitleStyles> */}
      {/* <EditableTable loading={loading} material={material} columns={columns} dataSource={dataSource} /> 
      */}
      <CapMaterialsTable
        pagination={capMaterialPagination}
        onPaginationChange={onCapMaterialPaginationChange}
        onActivityLogClick={onActivityLogClick}
      />
      <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
      <TableTitleStyles>Other Material</TableTitleStyles>
        <EditableTable 
          loading={loading} 
          material={material} 
          columns={columns} 
          dataSource={safeDataSource}
          onTableChange={handleOtherMaterialTableChange}
          pagination={{
            current: otherMaterialPagination?.current || 1,
            pageSize: otherMaterialPagination?.pageSize || 10,
            total: otherMaterialTotalCount || 0,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: (page, size) => {
              onOtherMaterialPaginationChange(page, size);
            },
            onShowSizeChange: (current, size) => {
              onOtherMaterialPaginationChange(1, size);
            },
          }}
        />
      </div>
    </div>
  );
};

export default CapMaterialTable;
